import { render, staticRenderFns } from "./messUpload.vue?vue&type=template&id=33fea572&scoped=true&"
import script from "./messUpload.vue?vue&type=script&lang=js&"
export * from "./messUpload.vue?vue&type=script&lang=js&"
import style0 from "./messUpload.vue?vue&type=style&index=0&id=33fea572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fea572",
  null
  
)

export default component.exports